/**
 * @file Expert dashboard UI — pages/Dashboard/Expert/Submissions/components/LoadingState.tsx.
 */

import React from "react";
import AnalysisBanner from "../../../../../components/common/AnalysisBanner";

const LoadingState: React.FC = () => {
  return (
    <div className="background-form-container analysis-shell">
      <AnalysisBanner title="Review Submissions" />
      <p className="expert-info-text">Loading submissions...</p>
    </div>
  );
};

/** React component — Loading State. */
export default LoadingState;

